module.exports = __webpack_public_path__ + "media/images/icon_map-447d3debcfb07c4ef7b6fb7500d42555.png";